import { HttpClient } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {Room} from '../shared/Room';
import {MiniBookAdminService} from './mini-book-admin.service';

export class RoomService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getRooms(): Observable<Room[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/rooms`).pipe(
      map<any[], Room[]>(data => data.map(value => Room.createFromJson(value)))
    );
  }

  createRoom(room: Room): Observable<Room> {
    return this.http.post<any>(`${this.adminService.tenant}/rooms`, room.toJson()).pipe(
      map<any, Room>(data => Room.createFromJson(data))
    );
  }

  getRoom(id: number): Observable<Room> {
    return this.http.get<any>(`${this.adminService.tenant}/rooms/${id}`).pipe(
      map<any, Room>(data => Room.createFromJson(data))
    );
  }

  updateRoom(id: number, room: Room): Observable<Room> {
    return this.http.put<any>(`${this.adminService.tenant}/rooms/${id}`, room.toJson()).pipe(
      map<any, Room>(data => Room.createFromJson(data))
    );
  }

  deleteRoom(id: number, forced: boolean): Observable<void> {
    let force = "";
    if (forced) {
      force = "?force=true";
    }
    return this.http.delete<void>(`${this.adminService.tenant}/rooms/${id}${force}`);
  }
}
